import React from "react"
import { t, hours, money, percent, varianceTone, performanceTone } from "../format"
import { ConsumptionBar } from "./Charts"

export const GRID = "grid grid-cols-[minmax(260px,2.4fr)_76px_76px_96px_150px_72px_86px_104px_112px_64px] gap-3 items-center"

export const Figures = ({ row, currency, compact = false }) => (
  <>
    <div className="text-right tabular-nums text-slate-700">{hours(row.sold)}</div>
    <div className="text-right tabular-nums text-sky-700">{hours(row.planned)}</div>
    <div className="text-right tabular-nums">
      <div className={`font-semibold ${row.sold > 0 && row.done > row.sold ? "text-rose-700" : "text-slate-900"}`}>{hours(row.done)}</div>
      {!compact && row.done > 0 && (
        <div className={`text-[10.5px] ${row.pending > 0 ? "text-amber-700" : "text-slate-400"}`}>
          {row.pending > 0 ? t("table.to_approve", { hours: hours(row.pending) }) : t("table.all_approved")}
        </div>
      )}
    </div>
    <div className="min-w-0">
      <ConsumptionBar consumed={row.consumed} progress={row.progress} progressKnown={row.progress_known} />
      <div className="mt-1 flex justify-between text-[10.5px] tabular-nums text-slate-500">
        <span>{t("table.consumed_short", { pct: percent(row.consumed) })}</span>
        <span>{row.progress_known ? t("table.progress_short", { pct: percent(row.progress) }) : t("table.no_progress")}</span>
      </div>
    </div>
    <div className={`text-right tabular-nums font-medium ${performanceTone(row.performance)}`}>
      {row.performance ? percent(row.performance * 100) : "–"}
    </div>
    <div className="text-right tabular-nums text-slate-700">{hours(row.projected)}</div>
    <div className="text-right tabular-nums">
      <div className={`font-semibold ${varianceTone(row.projected_variance, row.sold)}`}>{hours(row.projected_variance, { signed: true })}</div>
      {!compact && <div className="text-[10.5px] text-slate-400">{money(row.projected_variance_cents, currency, { signed: true })}</div>}
    </div>
    <div className="text-right tabular-nums">
      <div className={row.cost_budget_cents > 0 && row.cost_actual_cents > row.cost_budget_cents ? "text-rose-700 font-medium" : "text-slate-800"}>
        {money(row.cost_actual_cents, currency)}
      </div>
      <div className="text-[10.5px] text-slate-400">{t("table.of_budget", { money: money(row.cost_budget_cents, currency) })}</div>
    </div>
  </>
)
